
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from '../Header/Header';

import Cookies from 'universal-cookie';
import MainMenu from '../MainMenu/MainMenu';
import ExcelReport from '../Report/ExcelReport';
import Dashboard from '../Dashboard/Dashboard';
import LiveChannels from '../LiveChannels/LiveChannels';
import LiveDevices from '../LiveDevices/LiveDevices';
import LiveMap from "../LiveChannels/LiveMap";
import ChannelStatus from '../Channel/ChannelStatus';
import AdLogUpload from '../LogUpload/AdLogUpload';
import CategorialAudienceCount from '../CategorialAudienceCount/CategorialAudienceCount';
import ProgramLogUpload from '../LogUpload/ProgramLogUpload';
import DayRangedChannelStatus from '../Channel/DayRangedChannelStatus';
import RangedChannelStatus from '../Channel/RangedChannelStatus';
import DefinedChannelStatus from '../Channel/DefinedChannelStatus';
import DeviceMonitor from '../DeviceMonitor/DeviceMonitor';
import DeviceDeploymentCheck from '../DeviceHealth/DeviceDeploymentCheck';
import UserStatus from '../User/UserStatus';
import UserDefined from '../User/UserDefined';
import Overview from '../Overview/Overview';
import ViewLog from '../ViewLog/ViewLog';
import ViewLog2 from '../ViewLog/ViewLog2';
import AppUserList from "../AppUsers/AppUserList";

import AddAppUser from "../AppUsers/AddAppUser";
import EditAppUser from "../AppUsers/EditAppUser";
import ChangePass from "../AppUsers/ChangePass";
import DeviceInfo from "../Devices/DeviceInfo";
import Footer from "../Footer/Footer";
import EditProfile from "../AppUsers/EditProfile";
import DeviceList from "../DeviceUser/DeviceList";
import AddDevice from "../DeviceUser/AddDevice";
import EditDevice from "../DeviceUser/EditDevice";
import AddUser from "../DeviceUser/User/AddUser";
import EditUser from "../DeviceUser/User/EditUser";
import DeviceDetails from "../DeviceUser/DeviceDetails";
import DeviceDetailsView from "../DeviceUser/DeviceDetailsView";
import Notification from "../Header/Notification";
import NoticeBoard from "../Notification/NoticeBoard";
import ViewlogRawData from "../ViewlogRawData/ViewlogRawData";
import ViewlogRawDataUnpublished from "../ViewlogRawData/ViewlogRawDataUnpublished";
import UserDataFilter from "../User/UserDataFilter";
import DataCleanse from "../User/DataCleanse";
import UserPassReset from "../AppUsers/PassReset/UserPassReset";
import ResetPass from "../AppUsers/PassReset/ResetPass";
import DeviceHistoryLog from "../DeviceUser/DeviceHistoryLog";
import DeviceLiveDisableHistory from "../DeviceUser/DeviceLiveDisableHistory";
import AppUserLoginSessions from "../AppUsers/AppUserLoginSessions";
import AppUserActivityLog from "../AppUsers/AppUserActivityLog";
import DeviceViewingStatusList from "../DeviceUser/DeviceViewingStatusList";
import DeselectLog from "../DeselectLog/DeselectLog";
import MapLocation from "../AppUsers/MapLocation/MapLocation";
import DeviceDeselectHistory from "../DeviceUser/DeviceDeselectHistory";
import BoxHistoryLog from "../DeviceUser/BoxHistoryLog";
import ChannelList from "../ChannelList/ChannelList";
import DeviceDeployment from "../DeviceHealth/DeviceDeployment";
import ChannelSubscriptionLists from "../ChannelSubscription/ChannelSubscriptionLists";
import ChannelSubscriptionHistory from "../ChannelSubscription/ChannelSubscriptionHistory";



function DeployerAdmin() {

  const cookies = new Cookies();
  return (
    <div>


      <BrowserRouter>
        <MainMenu />
        <Routes>
          <Route exact path="/" element={<DeviceDeployment />}></Route>
          <Route exact path="/device-check" element={<DeviceDeployment />}></Route>
          
          <Route exact path="/device/viewing-status" element={<DeviceViewingStatusList />}></Route>

          <Route exact path="/device" element={<DeviceList />}></Route>
          <Route exact path="/device/edit/:id" element={<EditDevice />}></Route>
          <Route exact path="/device/user/create/:device_id/:user_index/:from" element={<AddUser />}></Route>
          <Route exact path="/device/user/edit/:id/:from" element={<EditUser />}></Route>
          <Route exact path="/device/user/details/:id" element={<DeviceInfo />}></Route>

          <Route exact path="/device/detail/:id" element={<DeviceDetailsView />}></Route>
          <Route exact path="/device/deselect/history/:id" element={<DeviceDeselectHistory />}></Route>
          <Route exact path="/device/box/history/:id" element={<DeviceHistoryLog />}></Route>
          <Route exact path="/device/live-disable/history/:id" element={<DeviceLiveDisableHistory />}></Route>


          <Route exact path="/app/user/changepass" element={<ChangePass />}></Route>

          {/* <Navigate to="/" /> */}
          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />
          {/* <Route exact path="/map" element={<Map />}></Route> */}
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default DeployerAdmin;
